var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{class:[
    'header',
    { 'is-scrolled': _setup.isScrolled, 'drawer-opened': _setup.drawerOpened },
  ]},[_c('router-link',{attrs:{"to":"/"}},[(_vm.$i18n.locale === 'ja-JP')?[_c('img',{staticClass:"logo",attrs:{"src":"/img/top/logo.min.svg","alt":"ケミカン - SDSを正確にデータ化"}})]:[_c('img',{staticClass:"logo",attrs:{"src":"/img/top/logo.en.min.svg","alt":"Chemical - Accurate SDS Data"}})]],2),_c(_setup.LPHeaderMenuSp,{attrs:{"drawer-opened":_setup.drawerOpened},on:{"toggleDrawer":_setup.handleToggleDrawer}}),_c(_setup.LPHeaderMenuPc)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }